module.exports = __webpack_public_path__ + "img/instruction.753caaed.png";